require('./component-blog.js');
require('./component-blog-author.js');
require('./component-blog-list.js');
require('./component-blog-related.js');
require('./component-blog-latest-posts.js');